export default __webpack_public_path__ + "static/media/italy.763e6a99.png";